import styled from "../../settings/theme/styled";

export const Section = styled.div`
  height: 100%;
  box-sizing: border-box;
  max-width: 1100px;
  padding: 8vmin;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
`;
